import { render, staticRenderFns } from "./DicCascader.vue?vue&type=template&id=176fcea6&scoped=true"
import script from "./DicCascader.vue?vue&type=script&lang=js"
export * from "./DicCascader.vue?vue&type=script&lang=js"
import style0 from "./DicCascader.vue?vue&type=style&index=0&id=176fcea6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176fcea6",
  null
  
)

export default component.exports